//  Version : 0.0.1
//  Author : VISHNU
// LastEdit : KARTHEESWARAN
// LASTADD : Removed excel Redux
// MODFIED DATE:12-11-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*************** GET ARREAR FOLLOWUP LIST START ************/
export const ArrearFollowupListGet = (listData: any) => {
	const data = {
		GetArrearFollowUpReportToken: listData,
	};
	const url = `${API_URL}getAllFollowUp`;

	return makeApiCall(url, data);
};
/*************** GET ARREAR FOLLOWUP LIST END ************/
